import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetCsvExcelTradesService } from "@/features/accounts/csv-excel/services/get-trades-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { GetCsvExcelTradesResponseModel } from "@/features/accounts/csv-excel/services/get-trades-model";


export const useGetCsvExcelTrades = () => {
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);
  const getCsvExcelTradesService = new GetCsvExcelTradesService();

  // CsvExcel明細一覧取得
  const getCsvExcelTrades = async (
    accountGroupId: string,
    csvexcelAccountId: string,
    startDate?: string,
    endDate?: string,
  ) :Promise<GetCsvExcelTradesResponseModel[]> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getCsvExcelTradesService.getCsvExcelTrades({
        account_group_id:  accountGroupId,
        csvexcel_account_id: csvexcelAccountId,
        ...(startDate !== undefined && { start_date: startDate }),
        ...(endDate !== undefined && { end_date: endDate }),
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getCsvExcelTrades:", error);
      throw error;
      // return [];
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getCsvExcelTrades: errorHandledAsync(getCsvExcelTrades, setError),
  };
};
